import Type from "@/model/types/Type";

const type = {
    DEFAULT: 1 /*MLS, Luisa, Fernanda*/,

    TEXT_OVERLAY_TOP: 10, /*Citrino*/
    LIGHT_BORDER_BOTTOM_TEXT: 11, /*Defensoria SP*/
    HIGHLIGHT_PRESENTATION: 15, /*NÃO UTILIZADO*/

    TECHNICAL_HEADER_BORDER: 20, /*Racon Engenharia*/
    TECHNICAL_THICK_BORDER: 21, /*Fulvio*/
}

const list = [

    /*
     |--------------------------------------------------------------------------
     | Simples
     |--------------------------------------------------------------------------
     */

    {
        value: type.DEFAULT,
        text: 'Padrão (Legenda abaixo centralizada)',
        title: 'Padrão',
        description: 'Imagens centralizadas com legenda descritiva abaixo de cada foto.',
        badge: '',
        preview: 'https://static.onlaine.com.br/report-evidence/evidence_report_design_1.png'
    },

    {
        value: type.TEXT_OVERLAY_TOP,
        text: 'Minimalista (Texto sobreposto superior)',
        title: 'Minimalista',
        description: 'Layout limpo com descrição sobreposta na parte superior da imagem.',
        badge: '',
        preview: 'https://static.onlaine.com.br/report-evidence/evidence_report_design_10.png'
    },

    {
        value: type.LIGHT_BORDER_BOTTOM_TEXT,
        text: 'Borda Leve (Moldura discreta inferior)',
        title: 'Borda Leve',
        description: 'Fotos com moldura discreta e descrição abaixo da imagem.',
        badge: '',
        preview: 'https://static.onlaine.com.br/report-evidence/evidence_report_design_11.png'
    },

    /*
     |--------------------------------------------------------------------------
     | Apresentação
     |--------------------------------------------------------------------------
     */

    {
        value: type.HIGHLIGHT_PRESENTATION,
        text: 'Destaque (Maior valorização visual)',
        title: 'Destaque',
        description: 'Maior valorização visual das imagens com foco em apresentação.',
        badge: '',
        preview: 'https://static.onlaine.com.br/report-evidence/evidence_report_design_15.png'
    },

    /*
     |--------------------------------------------------------------------------
     | Técnicos
     |--------------------------------------------------------------------------
     */

    {
        value: type.TECHNICAL_HEADER_BORDER,
        text: 'Técnico Completo (Cabeçalho técnico superior)',
        title: 'Técnico Completo',
        description: 'Cabeçalho com título e período do trabalho, além de moldura técnica reforçada.',
        badge: '',
        preview: 'https://static.onlaine.com.br/report-evidence/evidence_report_design_20.png'
    },

    {
        value: type.TECHNICAL_THICK_BORDER,
        text: 'Técnico Reforçado (Moldura técnica espessa)',
        title: 'Técnico Reforçado',
        description: 'Fotos com moldura mais espessa e descrição abaixo da imagem.',
        badge: '',
        preview: 'https://static.onlaine.com.br/report-evidence/evidence_report_design_21.png'
    }

]

/*
 |--------------------------------------------------------------------------
 | Helpers
 |--------------------------------------------------------------------------
 */

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

const isTechnicalLayout = function (layout) {
    return [
        type.TECHNICAL_HEADER_BORDER,
        type.TECHNICAL_THICK_BORDER
    ].includes(layout)
}

const isPresentationLayout = function (layout) {
    return [
        type.HIGHLIGHT_PRESENTATION
    ].includes(layout)
}

const isOverlayLayout = function (layout) {
    return [
        type.TEXT_OVERLAY_TOP
    ].includes(layout)
}

const isBorderLayout = function (layout) {
    return [
        type.LIGHT_BORDER_BOTTOM_TEXT,
        type.TECHNICAL_HEADER_BORDER,
        type.TECHNICAL_THICK_BORDER
    ].includes(layout)
}

const isSimpleLayout = function (layout) {
    return [
        type.DEFAULT,
        type.LIGHT_BORDER_BOTTOM_TEXT
    ].includes(layout)
}

const isFullWidthLayout = function (layout) {
    return [
        type.HIGHLIGHT_PRESENTATION,
        type.TECHNICAL_THICK_BORDER
    ].includes(layout)
}

const isBottomDescriptionLayout = function (layout) {
    return [
        type.DEFAULT,
        type.LIGHT_BORDER_BOTTOM_TEXT,
        type.TECHNICAL_THICK_BORDER
    ].includes(layout)
}

const isTopDescriptionLayout = function (layout) {
    return [
        type.TEXT_OVERLAY_TOP,
        type.TECHNICAL_HEADER_BORDER
    ].includes(layout)
}

const isHeavyBorderLayout = function (layout) {
    return [
        type.TECHNICAL_THICK_BORDER
    ].includes(layout)
}

const isMinimalLayout = function (layout) {
    return [
        type.DEFAULT,
        type.TEXT_OVERLAY_TOP
    ].includes(layout)
}

export default {
    type,
    list,

    contains,

    isTechnicalLayout,
    isPresentationLayout,
    isOverlayLayout,
    isBorderLayout,
    isSimpleLayout,
    isFullWidthLayout,
    isBottomDescriptionLayout,
    isTopDescriptionLayout,
    isHeavyBorderLayout,
    isMinimalLayout,
}